module.exports = __webpack_public_path__ + "img/img_smart_img1.8c1a580d.png";